export default "/images/ellipse_blue.svg?448d6c49f73d789921bcb5e1aef6b6f6";